export default __webpack_public_path__ + "static/media/Asc_White.17e90573.png";